import { render, staticRenderFns } from "./units-list.vue?vue&type=template&id=e0d53c92&scoped=true"
import script from "./units-list.vue?vue&type=script&lang=js"
export * from "./units-list.vue?vue&type=script&lang=js"
import style0 from "./units-list.vue?vue&type=style&index=0&id=e0d53c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d53c92",
  null
  
)

export default component.exports